import {
  TreePine,
  Scissors,
  Sprout,
  Hammer,
  Waves,
  Droplets,
  Leaf,
  Shield,
  Shovel,
  Layers,
} from "lucide-react";

const services = [
  {
    icon: TreePine,
    title: "Tree Removal",
    desc: "Safe removal of any tree — storm damaged, dying, or simply in the way. Full cleanup included.",
    span: "md:col-span-6",
  },
  {
    icon: Scissors,
    title: "Tree Trimming",
    desc: "Professional arborist pruning to keep trees healthy, balanced, and hurricane-ready.",
    span: "md:col-span-6",
  },
  {
    icon: Shovel,
    title: "Stump Grinding",
    desc: "Grind it down below grade. Reclaim your yard.",
    span: "md:col-span-4",
  },
  {
    icon: Leaf,
    title: "Landscaping",
    desc: "Full-service design, install and ongoing maintenance for residential & commercial.",
    span: "md:col-span-4",
  },
  {
    icon: Waves,
    title: "Pool Builds",
    desc: "Custom pool construction and surround hardscaping.",
    span: "md:col-span-4",
  },
  {
    icon: Layers,
    title: "Patios & Hardscape",
    desc: "Paver patios, walkways and outdoor living spaces.",
    span: "md:col-span-3",
  },
  {
    icon: Droplets,
    title: "Irrigation",
    desc: "Install, repair, and optimize sprinkler systems.",
    span: "md:col-span-3",
  },
  {
    icon: Sprout,
    title: "Yard Cleanup",
    desc: "Debris hauled. Beds edged. Grounds left spotless.",
    span: "md:col-span-3",
  },
  {
    icon: Shield,
    title: "Storm Prep",
    desc: "Pre-hurricane pruning & post-storm emergency response.",
    span: "md:col-span-3",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 bg-[#F4F1EA]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 mb-16 items-end">
          <div className="lg:col-span-7">
            <div className="overline mb-4">What We Do</div>
            <h2 className="h-section text-[#0B1810]">
              Tree, Turf &<br />
              <span className="text-[#FF5A00]">Terrain.</span>
            </h2>
          </div>
          <p className="lg:col-span-5 text-lg text-[#4A4D4A] font-body">
            Ten services. One crew. Whether it's a 60-foot palm overhanging
            your roofline in Cocoa Beach or a weekend landscape refresh in
            Rockledge, Ben and his team bring arborist-grade skill and
            heavy equipment to every job across Brevard County, Florida.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
          {services.map((s) => (
            <div
              key={s.title}
              data-testid="service-card"
              className={`service-card ${s.span}`}
            >
              <div className="w-12 h-12 bg-[#FF5A00] flex items-center justify-center mb-5">
                <s.icon className="text-white" size={24} strokeWidth={2.5} />
              </div>
              <h3 className="font-heading text-2xl md:text-3xl text-[#0B1810] mb-2">
                {s.title}
              </h3>
              <p className="text-[#4A4D4A] font-body text-base leading-relaxed">
                {s.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-6">
          <div className="bg-[#0B1810] text-white p-10 relative overflow-hidden">
            <div className="overline text-[#FF5A00] mb-3">Residential</div>
            <h3 className="font-heading text-4xl md:text-5xl mb-4">
              For Your Home.
            </h3>
            <p className="text-white/70 font-body mb-6 max-w-md">
              One call handles the whole yard — from dangerous oaks in
              Rockledge to a simple palm trim in Cocoa Beach. Free quotes,
              upfront pricing, insured work across Brevard County, Florida.
            </p>
            <a href="#contact" className="btn-primary">
              Request a Quote
            </a>
          </div>
          <div
            className="p-10 relative overflow-hidden text-white"
            style={{
              backgroundImage:
                "linear-gradient(rgba(11,24,16,0.78), rgba(11,24,16,0.78)), url('https://images.unsplash.com/photo-1740474720127-099e04473772?auto=format&fit=crop&w=1600&q=80')",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="overline text-[#FF5A00] mb-3">Commercial</div>
            <h3 className="font-heading text-4xl md:text-5xl mb-4">
              For Your Business.
            </h3>
            <p className="text-white/80 font-body mb-6 max-w-md">
              HOAs, properties, storefronts across Melbourne, Viera, Merritt
              Island and Cape Canaveral — we keep grounds professional and
              liability-free. Scheduled maintenance or one-off projects.
            </p>
            <a href="#contact" className="btn-ghost-inverse">
              Talk to Ben
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
